import type { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router'
import { Site, SLD } from '@patsnap-utils/biz';

interface RedirectRule {
    pattern: RegExp
    replacement: string
}

const redirectRules: RedirectRule[] = [
    { pattern: /^\/results\/standard(?=\/|$|\?)/, replacement: 'results/#/standard' },
    { pattern: /^\/results\/design(?=\/|$|\?)/, replacement: 'results/#/design' },
    { pattern: /^\/results\/analysis(?=\/|$|\?)/, replacement: 'results/#/analysis' },
    { pattern: /^\/technology-roadmap\/#\/create$/, replacement: 'roadmap/create' },
    { pattern: /^\/technology-roadmap\/#\/detail(\/.*)?$/, replacement: 'roadmap-view/#/detail$1' },
    { pattern: /^\/technology-roadmap(\/|\/#|\/#\/)?$/, replacement: 'roadmap' },
    { pattern: /^\/air\/#\/page(\/.*)?$/, replacement: 'page$1' },
    { pattern: /^\/material(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/material\/search(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/home\/chat(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/home\/search(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/material\/chat(\/|\/#|\/#\/)?$/, replacement: 'home' },
    { pattern: /^\/air\/#\/user-setting\/package(\/|\/#|\/#\/)?$/, replacement: 'user-setting/package' },
    { pattern: /^\/air\/#\/user-setting\/amount(\/|\/#|\/#\/)?$/, replacement: 'user-setting/amount' },
    { pattern: /^\/air(\/|\/#|\/#\/)?(\?.*)?$/, replacement: 'home' },
    { pattern: /^\/newsletter\/#\/detail\/(\d+)(?=\/|$|\?)/, replacement: 'monitor/#/report/$1' },
    { pattern: /^\/newsletter\/#\/mySubscription(?=\/|$|\?)/, replacement: 'monitor/#/my' },
    { pattern: /^\/newsletter\/#\/topics(?=\/|$|\?)/, replacement: 'monitor/#/topics' },
    { pattern: /^\/newsletter\/#\/subscription(?=\/|$|\?)/, replacement: 'monitor/#/subscription' },
    { pattern: /^\/newsletter\/#\/result(?=\/|$|\?)/, replacement: 'monitor/#/result' },
    { pattern: /^\/newsletter(?=\/|$|\?)/, replacement: 'monitor' },
    { pattern: /^\/user-setting\/package\/(.*)/, replacement: 'user-setting/package/$1' }
]

function getRedirectPath(path: string): string | null {
    for (const { pattern, replacement } of redirectRules) {
        if (pattern.test(path)) {
            return path.replace(pattern, replacement)
        }
    }
    return null
}

export const deprecatedRouter: RouteRecordRaw = {
    path: '/:catchAll(.*)',
    component: () => {},
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
        const newPath = getRedirectPath(to.fullPath)
        if (newPath) {
            const fullPath = new Site({ sld: SLD.EUREKA, pathname: newPath }).href
            window.location.replace(fullPath)
        } else {
            next('/404')
        }
    },
}
